import type { shared as sharedEn } from "../en/shared";

export const shared: typeof sharedEn = {
  login: {
    administration: "Administrace",
    signInTitle: "Přihlášení",
    signInButton: "Přihlásit se",
    signingIn: "Přihlašuji…",
    password: "Heslo",
    emailPlaceholder: "vas@email.cz",
    copyright: "© {{year}} CK Go2. Všechna práva vyhrazena.",
  },
  auth: {
    loginFailed: "Přihlášení se nezdařilo",
  },
  apiClient: {
    uploadFailed: "Nahrání se nezdařilo",
    loadFileFailed: "Soubor se nepodařilo načíst ({{status}})",
    networkError: "Nelze se připojit k serveru. Zkontrolujte připojení k internetu.",
    invalidResponse: "Neplatný formát odpovědi",
    requestFailedStatus: "Požadavek selhal ({{status}})",
    requestFailed: "Požadavek selhal",
  },
  editPage: {
    conflictChoice:
      "OK = přepsat jejich změny vašimi\nZrušit = ponechat vaše úpravy (nejnovější verzi uvidíte po obnovení stránky).",
  },
  errorBoundary: {
    unexpected: "Došlo k neočekávané chybě.",
    reload: "Obnovit stránku",
  },
  editPageHeader: {
    createNew: "Vytváříte: {{name}}",
    editing: "Upravujete: {{name}}",
    view: "Zobrazit",
  },
  validationBanner: {
    title: "Formulář nelze uložit — opravte prosím tato pole:",
  },
  listSort: {
    recent: "Naposledy upravené",
    titleAsc: "Název A–Z",
    orderAsc: "Podle pořadí",
    priceAsc: "Cena od nejnižší",
    withoutDestination: "Bez destinace",
  },
  facetedList: {
    searchPlaceholder: "Hledat…",
    filters: "Filtry",
    clearCount: "Vymazat ({{count}})",
    showAll: "Zobrazit vše ({{count}})",
    showLess: "Zobrazit méně",
    showingRange: "Zobrazeno {{from}}–{{to}} z {{total}}",
  },
  notifications: {
    title: "Oznámení",
    markAllRead: "Označit vše jako přečtené",
    empty: "Žádná oznámení",
    justNow: "teď",
    minutesShort: "{{count}} min",
    hoursShort: "{{count}} h",
    daysShort: "{{count}} d",
  },
  aiReview: {
    title: "AI asistent",
    subtitle: "Vložte e-mail / zprávu pro předvyplnění poptávky",
    inputPlaceholder: "Sem vložte poptávku zákazníka…",
    parseButton: "Vytěžit pomocí AI",
    parseFailed: "Nepodařilo se vytěžit — zkuste to znovu nebo vyplňte ručně.",
    score: "Skóre {{score}}",
    avgConfidence: "{{percent}} % průměrná jistota",
    returningCustomer: "Vracející se zákazník:",
    existingLead: "Existující otevřená poptávka {{leadNumber}} ({{status}})",
    suggestedReply: "Navržená odpověď",
    applyToForm: "Použít do formuláře",
    fields: {
      adults: "Dospělí",
      children: "Děti",
      summary: "Shrnutí",
    },
  },
  faqEditor: {
    empty: "Zatím žádné kategorie FAQ. Přidejte kategorii nebo předvyplňte výchozí.",
    expand: "Rozbalit",
    collapse: "Sbalit",
    topicPlaceholder: "např. „Obecné“, „Užitečné tipy“, „Rezervace“",
    defaultTopic: "Obecné",
    moveCategoryUp: "Posunout kategorii nahoru",
    moveCategoryDown: "Posunout kategorii dolů",
    deleteCategory: "Smazat kategorii",
    moveTo: "Přesunout do…",
    categoryN: "Kategorie {{number}}",
    question: "Otázka",
    questionPlaceholder: "např. Jak velké jsou vaše skupiny?",
    answer: "Odpověď",
    answerPlaceholder: "Odpověď na otázku…",
    addQuestion: "+ Přidat otázku",
    addCategory: "+ Přidat kategorii",
    prefillDefaults: "Předvyplnit výchozí",
  },
  headingHero: {
    title: "Nadpis a hero",
    heroTitle: "Titulek na hero obrázku",
    heroPlaceholder: "např. Dobrodružství ve Vietnamu",
    heroHint:
      "Krátký text zobrazený na hero obrázku (2–5 slov). Pokud je prázdný, použije se {{fallback}}.",
    heading: "Hlavní nadpis stránky (H1)",
    headingPlaceholder: "např. Objevte krásy Vietnamu od severu k jihu",
    headingHint:
      "Hlavní nadpis pod hero sekcí. Může být delší a popisnější. Pokud je prázdný, použije se {{fallback}}.",
    fallbackTitle: "Titulek",
  },
  mediaPicker: {
    dragToReorder: "Přetažením změníte pořadí",
    selectOrUpload: "Vybrat nebo nahrát",
    change: "Změnit",
    doneBackToLibrary: "Hotovo — zpět do knihovny",
  },
  orderItems: {
    unitPrice: "Jednotková cena",
    qty: "Počet",
    lineTotal: "Celkem za řádek",
    empty: "Zatím žádné položky",
    itemNamePlaceholder: "Název položky",
    priceOverride: "Přepsaná cena — katalogový zájezd zůstává beze změny",
    addLine: "Přidat řádek",
    addAddon: "Doplněk",
    addDiscount: "Sleva",
  },
  readiness: {
    title: "Připravenost",
    readyCount: "{{done}}/{{total}} připraveno",
    markDone: "Označit jako hotové",
    markNotDone: "Označit jako nehotové",
    done: "Hotovo",
    addPlaceholder: "např. Zjistit stravovací preference",
    addItem: "Přidat položku checklistu",
  },
  recentCalls: {
    title: "Poslední hovory",
    showTranscript: "Zobrazit přepis",
    hideTranscript: "Skrýt přepis",
    followUpScheduled: "Follow-up naplánován",
    followUpFailed: "Follow-up se nepodařilo použít",
    proposedFollowUp: "Navržený follow-up {{date}}",
    scheduled: "Naplánováno",
  },
  relatedItems: {
    defaultLabel: "Související položky",
    searchPlaceholder: "Hledat položky…",
    selectedCount: "Vybráno ({{count}})",
    noMatches: "Žádné odpovídající položky",
    noItems: "Žádné položky k dispozici",
  },
  destinationPicker: {
    searchPlaceholder: "Hledat destinaci…",
    none: "Bez destinace",
    draft: "koncept",
    loading: "Načítám destinace…",
    noMatches: "Nic nenalezeno",
    loadError: "Destinace se nepodařilo načíst.",
    retry: "Zkusit znovu",
    removeTag: "Odebrat štítek",
  },
  roomTypes: {
    title: "Typy pokojů",
    hint: "Nákupní cena za pokoj pro každý nabízený typ pokoje. Používá se pro ubytování účtované po pokojích — rezervace vybere jeden typ a zafixuje jeho cenu; kalkulačka ji rozpočítá podle obsazenosti (jednolůžkový → bez spolubydlícího, příplatek vyjde automaticky). Nechte prázdné, pokud se má použít paušální cena výše.",
    costPerRoom: "Cena / pokoj",
    removeTitle: "Odebrat typ pokoje",
    add: "Přidat typ pokoje",
  },
  paxGrid: {
    show: "Přehled osob",
    hide: "Skrýt přehled osob",
    empty: "Zatím žádní cestující — nejdřív přidejte účastníky do objednávky.",
    traveller: "Cestující",
    paid: "Zaplaceno",
    issued: "Vystaveno",
    toGuide: "Předáno průvodci",
    checked: "Zkontrolováno",
  },
  serviceBookings: {
    title: "Služby",
    addService: "Přidat službu",
    editService: "Upravit službu",
    newService: "Nová služba",
    saveService: "Uložit službu",
    deviation: "odchylka",
    payBy: "zaplatit do {{date}}",
    perPaxSuffix: "/os.",
    perRoomSuffix: "/pokoj",
    fromCatalog: "Z katalogu",
    manualEntry: "— ruční zadání —",
    namePlaceholder: "např. Sofitel Metropole — 2 noci",
    kind: "Druh",
    roomType: "Typ pokoje",
    flatCost: "— paušální cena —",
    allotmentLabel_one: "Skupinová alokace (čerpá {{count}} místo z bloku)",
    allotmentLabel_few: "Skupinová alokace (čerpá {{count}} místa z bloku)",
    allotmentLabel_other: "Skupinová alokace (čerpá {{count}} míst z bloku)",
    noBlock: "— FIT / bez bloku —",
    supplier: "Dodavatel",
    none: "— žádný —",
    matching: "Odpovídající",
    otherSuppliers: "Ostatní dodavatelé",
    cost: "Cena",
    scope: "Rozsah",
    pax: "Osob",
    confirmBy: "Potvrdit do",
    paxCountBy: "Počet osob do",
    payByLabel: "Zaplatit do",
    notesLabel: "Poznámky / detaily",
    notesPlaceholder: "PNR, rooming list, čísla pojistek…",
    customizationLabel: "Poznámka k úpravě (odchylka od standardu — zobrazí se průvodci)",
    customizationPlaceholder:
      "např. Upgrade na 5★ (standard byl 3★) — nechte prázdné, pokud jde o standard",
    supplierEmail: "E-mail dodavateli",
    generateDraft: "Vygenerovat návrh",
    linkSupplierFirst: "Nejdřív propojte dodavatele s e-mailem",
    noEmailOnFile: "{{name}} nemá uložený e-mail — doplňte ho v Dodavatelích.",
    thisSupplier: "Tento dodavatel",
    linkSupplierHint: "Pro návrh zprávy propojte výše dodavatele s e-mailem.",
    emailTo: "Komu: {{to}}",
    sent: "Odesláno ✓",
    sendViaGmail: "Odeslat přes Gmail",
    confirmations: "Potvrzení dodavatele",
    attachPdf: "Přiložit PDF",
    aiFill: "AI vyplnění",
    confirmationsHint:
      "Hotelový voucher / potvrzení rezervace — dostane se offline do průvodcovské aplikace.",
    aiFillHint: "přečte PDF a předvyplní údaje níže — zkontrolujte a uložte.",
    parseTitle: "Vytěžit potvrzení",
    parsePlaceholder: "Sem vložte letenku / pojištění / potvrzení hotelu…",
    extractDetails: "Vytěžit údaje",
    nothingExtracted: "Nic nebylo vytěženo.",
    addToNotes: "Přidat do poznámek",
    empty: "Zatím žádné služby. Přidejte hotely, letenky, pojištění…",
    supplierGroups: {
      airline: "Aerolinky",
      hotel: "Hotely",
      insurance: "Pojišťovny",
      transport: "Doprava",
      guide: "Průvodci",
      activity: "Aktivity",
      visa: "Vízoví agenti",
      other: "Ostatní",
    },
  },
  videoLink: {
    invalid: "Tento odkaz web nezobrazí. Podporované jsou odkazy na video z YouTube a Instagramu.",
  },
  socialReels: {
    empty: "Zatím žádné reels. Sekce se na webu nezobrazí.",
    reelN: "Reel {{number}}",
    titlePlaceholder: "Titulek reelu…",
    linkLabel: "Odkaz (volitelný)",
    thumbnail: "Náhled",
    addReel: "+ Přidat reel",
    inheritedLine_one:
      "Na webu se za těmito videi ukáže i video země {{country}} ({{count}}): {{titles}}",
    inheritedLine_few:
      "Na webu se za těmito videi ukážou i videa země {{country}} ({{count}}): {{titles}}",
    inheritedLine_other:
      "Na webu se za těmito videi ukážou i videa země {{country}} ({{count}}): {{titles}}",
    noLinkWarning: "Bez odkazu se na webu neukáže",
  },
  agent: {
    briefLabel: "Shrň mi to",
    briefHeading: "AI shrnutí",
    handoverLabel: "Předávací poznámka",
    handoverHeading: "Předávací poznámka",
    generateFailed: "Shrnutí se nepodařilo vygenerovat.",
    entityOrder: "Objednávka #{{id}}",
    entityLead: "Poptávka {{id}}",
    entityCustomer: "Zákazník {{id}}",
    entityDeparture: "Termín {{id}}",
    ask1: "Má průvodce Martin volno na zájezd 22.–29. 9.?",
    ask2: "Kolik lidí je přihlášeno na kurz vaření příští týden?",
    ask3: "Kolik cestujících na tomto zájezdu má naše pojištění a kolik vlastní?",
    ask4: "Které lety je ještě potřeba potvrdit před termínem?",
    ask5: "Jaká je marže na této objednávce?",
    do1: "Zduplikuj tuto objednávku, vynech plavbu a dej slevu 2 000 Kč.",
    do2: "Přesuň tuhle rezervaci na další termín a napiš hotelu o přebookování.",
    do3: "Připrav připomínku zálohy pro tohoto zákazníka.",
    do4: "Najdi náhradního průvodce pro tento termín a přiřaď ho.",
    attachFailed: "Soubor se nepodařilo přiložit",
    chatFailed: "Asistent narazil na chybu.",
    openAssistant: "Otevřít asistenta MAKEJ!",
    waitingApproval: "Čeká na vaše schválení ({{count}})",
    intro: "Přečtu si vše v CRM a připravím změny, které schválíte.",
    lookingAt: "Díváte se na",
    askHeading: "Zeptejte se mě třeba",
    doHeading: "…nebo mi nechte připravit změnu",
    noReply: "(žádná odpověď)",
    working: "Pracuji…",
    uploading: "Nahrávám…",
    removeAttachment: "Odebrat přílohu",
    attachTitle: "Přiložit fotku, PDF nebo CSV/textový soubor",
    inputPlaceholder: "Napište MAKEJ!…",
    approveAll: "Schválit vše",
    approvePlanFailed: "Plán se nepodařilo schválit",
    heldNotice_one:
      "Interní kroky provedeny. {{count}} odchozí/peněžní krok ještě čeká na vaše potvrzení níže.",
    heldNotice_few:
      "Interní kroky provedeny. {{count}} odchozí/peněžní kroky ještě čekají na vaše potvrzení níže.",
    heldNotice_other:
      "Interní kroky provedeny. {{count}} odchozích/peněžních kroků ještě čeká na vaše potvrzení níže.",
    tierRead: "čtení",
    tierWrite: "zápis",
    tierMoney: "peníze",
    executionFailed: "Provedení selhalo",
    approveFailed: "Schválení se nezdařilo",
    rejectFailed: "Zamítnutí se nezdařilo",
    loadDraftFailed: "Návrh se nepodařilo načíst",
    saveEditFailed: "Úpravu se nepodařilo uložit",
    revertFailed: "Vrácení se nezdařilo",
    revertNote: "Obnoveno: {{restored}}, přeskočeno (mezitím změněno): {{skipped}} — {{fields}}",
    subjectPlaceholder: "Předmět",
    bodyPlaceholder: "Text e-mailu",
    saveText: "Uložit text",
    approvedExecuted: "Schváleno a provedeno",
    reverted: "Vráceno",
    revert: "Vrátit zpět",
    dismissed: "Zamítnuto",
    confirmTier: "Opravdu potvrdit tuto akci ({{tier}})?",
    yesConfirm: "Ano, potvrdit",
    approve: "Schválit",
    dismiss: "Zamítnout",
    awaitingOperator: "Čeká na schválení operátorem.",
  },
};
